import { doesClipHaveMultipleScenes } from '@goldcast/player-config/src/utils/clipUtils';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { classnames } from '@/libs/utils';

interface ClipCustomizerMultipleSceneWarningProp {
  skipMargin?: boolean;
}
const ClipCustomizerMultipleSceneWarning = ({ skipMargin }: ClipCustomizerMultipleSceneWarningProp) => {
  const { clipData } = useClipsContext();
  if (!doesClipHaveMultipleScenes(clipData)) {
    return null;
  }

  return (
    <div
      className={classnames(
        'rounded-md border border-black border-opacity-10 bg-orange-50 px-3 py-2.5',
        skipMargin ? '' : 'mt-5'
      )}
    >
      <div className="font-medium">Scene changes detected</div>
      <div className="mt-1 font-light">
        There are custom scene changes in the timeline – applying a global layout will overwrite all existing scene
        changes
      </div>
    </div>
  );
};

export default ClipCustomizerMultipleSceneWarning;
